import React from "react";
import { useTranslation } from "react-i18next";
import { BulkLineItem } from "../../../../../model/bulk-purchase/bulk-purchase-customer";
import { formatCurrency } from "../../../../../utils";
import styles from "./added-meters.module.scss";

interface AddedMetersProps {
	items: BulkLineItem[];
	onEdit: (item: BulkLineItem) => void;
	onDelete: (id: string) => void;
	currency?: string;
}

const EditIcon: React.FC = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path d="M12 20h9M16.5 3.5a2.12 2.12 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5Z" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

const TrashIcon: React.FC = () => (
	<svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
		<path d="M3 6h18M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2m3 0v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
	</svg>
);

export const AddedMeters: React.FC<AddedMetersProps> = ({ items, onEdit, onDelete, currency = "NGN" }) => {
	const { t } = useTranslation();
	if (!items.length) return null;

	return (
		<div className={styles.container}>
			<p className={styles.heading}>
				{t("buyElectricity.bulk.addedMeters")} ({items.length})
			</p>
			<div className={styles.list}>
				{items.map(item => {
					const invalid = item.isValid === false;
					return (
						<div key={item.id} className={`${styles.row} ${invalid ? styles.rowInvalid : ""}`}>
							<div className={styles.info}>
								<span className={styles.number}>{item.name || item.meterNumber}</span>
								<span className={styles.meta}>
									<span className={styles.amount}>{formatCurrency(item.amount, { currency })}</span>
									<span className={styles.dot}>•</span>
									<span className={styles.type}>
										{item.serviceType === "Prepaid" ? t("common.labels.prepaid") : t("common.labels.postpaid")}
									</span>
								</span>
								{invalid && item.errors && item.errors.length > 0 && (
									<span className={styles.error}>{item.errors.join(", ")}</span>
								)}
							</div>
							<div className={styles.rowActions}>
								<button type="button" className={styles.iconBtn} onClick={() => onEdit(item)} aria-label={t("buyElectricity.bulk.edit")}>
									<EditIcon />
								</button>
								<button type="button" className={`${styles.iconBtn} ${styles.deleteBtn}`} onClick={() => onDelete(item.id)} aria-label={t("buyElectricity.bulk.delete")}>
									<TrashIcon />
								</button>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default AddedMeters;
